import { render } from "./ForbiddenView.vue?vue&type=template&id=175b1936"
import script from "./ForbiddenView.vue?vue&type=script&lang=js"
export * from "./ForbiddenView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__